import { useMemo } from 'react';
import { SpreadsheetConfig } from 'components/ScalarSpreadsheet/utilities/SpreadsheetConfig';
import { WaterfallSheetConfigProps } from './useWaterfallSheetConfig.props';
import { WaterfallSheetColumns, WaterfallSheetConfigParams } from './useWaterfallSheetConfig.types';
import WaterfallParser from '../WaterfallParser/WaterfallParser';
import WaterfallRowConfig from '../WaterfallRowConfig/WaterfallRowConfig';

const useWaterfallSheetConfig = ({
  scenarioObject,
  validSecurities,
  companyName,
  relatedEntityId = null,
}: WaterfallSheetConfigProps) => {
  const sheetConfig = useMemo(() => {
    if (scenarioObject && validSecurities) {
      const nameSuffix = relatedEntityId ? `.${relatedEntityId}` : '';
      return new SpreadsheetConfig<object, WaterfallSheetColumns, object>({
        rowConfig: WaterfallRowConfig({ scenarioObject, validSecurities, companyName }),
        columns: [
          { label: 'Security', keyName: 'securityName' },
          { label: 'Distribution', keyName: 'aggregateValue' },
          { label: 'Per Share', keyName: 'presentValue' },
        ],
        parser: WaterfallParser,
        isReadOnly: true,
        showTitlesColumn: false,
        name: `WaterfallSheet${nameSuffix}`,
      } as WaterfallSheetConfigParams);
    }
    return undefined;
  }, [scenarioObject, validSecurities, companyName, relatedEntityId]);

  return { sheetConfig };
};

export default useWaterfallSheetConfig;
